<template>
  <div class="space-y-2">
    <BaseFormLabel> Media </BaseFormLabel>
    <div class="p-4 bg-gray-100 rounded shadow-inner">
      <MediaList :acc-product-id="accProductId" />
    </div>
  </div>
</template>

<script>
import MediaList from './MediaList.vue';

export default {
  components: {
    MediaList,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
};
</script>
